import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { styled, fluidRange } from '~/styles';
import ReactGA from 'react-ga';
import stripHTML from '~/utils/stripHTML';

const StyledVideoPlayer = styled.div`
  video {
    @media (max-height: 768px) {
      /* margin-top: -35px; */
    }
  }
`;

function RenderVideo(props) {
  // local state
  const [started, setStarted] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [stopTime, setStopTime] = useState(0);

  const video__onProgress = ({playedSeconds}) => {
    if (!started) {
      setStarted(true);
      setStartTime(playedSeconds);
    }
    setStopTime(playedSeconds);
  }

  const video__onStop = () => {
    setStarted(false);
    setStartTime(stopTime);

    ReactGA.event({
      category: 'Video Playback',
      action: 'elapsed time',
      value: Math.trunc((stopTime - startTime) * 1000),
      label: stripHTML(props.config.title)
    });

    ReactGA.event({
      category: 'Video Playback',
      action: 'stop time',
      value: Math.trunc(stopTime * 1000),
      label: stripHTML(props.config.title)
    })
  }

  const video__onSeek = (seconds) => {
    setStartTime(seconds);
  }

  return (
    <StyledVideoPlayer>
      <ReactPlayer
        url={props.file} controls={true} wrapper='render-video'
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload'
            }
          }
        }}
        onProgress={({playedSeconds}) => { video__onProgress({playedSeconds}); }}
        onPause={video__onStop}
        onEnded={video__onStop}
        onSeek={(seconds) => video__onSeek(seconds)}
        />
    </StyledVideoPlayer>
    
  );
}

export default RenderVideo;



// WEBPACK FOOTER //
// ./src/components/parts/RenderVideo.tsx